import { buildRechercheStore } from '../shared'
import type { RechercheQueryProformaDTO } from '@/features/api/extranet/dto/Demande/Recherche/Proforma/RechercheQueryProFormaDTO'
import type { RechercheResultProformaDTO } from '@/features/api/extranet/dto/Demande/Recherche/Proforma/RechercheResultProformaDTO'

export const API_PATH_PROFORMA = '/proforma/demandes'

export const useRechercheProformaStore = buildRechercheStore<RechercheQueryProformaDTO, RechercheResultProformaDTO>({
  storeName: 'rechercheProformaStore',
  apiPath: API_PATH_PROFORMA,
  location: {
    to: 'recherche',
    domaine: 'dr',
    module: 'proforma'
  }
})
